import useSWR from "swr";
import { appConfig } from "../appConfig";
import { useMainDict } from "./useTranslation";
import { fetcher } from "../fetcher";
import { BlocksContent } from "@strapi/blocks-react-renderer";
import { StrapiNextImageType } from "@/types";

export type TermsAndConditionsType = {
  id: number;
  attributes: {
    createdAt: string;
    updatedAt: string;
    publishedAt: string;
    title: string;
    links: { href: string; label: string }[];
    text: BlocksContent;
  };
};

type TermsAndConditionsResponseType = {
  data: TermsAndConditionsType;
  meta: {};
};

const getApiRoute = (language: string) =>
  `/terms-and-condition?locale=${language}&populate=*`;

export async function preFetchTermsAndConditions(language: string) {
  try {
    const apiRoute = getApiRoute(language);

    const data = await fetcher<TermsAndConditionsResponseType>(apiRoute);

    return { [apiRoute]: data };
  } catch (error) {
    console.error(error);
    return null;
  }
}

export function useTermsAndConditions() {
  const { language } = useMainDict();

  const { data, isLoading } = useSWR<TermsAndConditionsResponseType>(
    getApiRoute(language),
    {
      refreshInterval: 0,
    }
  );

  return { termsAndConditions: data?.data, isLoading };
}
